export default "__VITE_ASSET__CcsMtez1__"